import React from 'react';
import { cn } from '@wwe-portal/ui/lib/lib';

interface SearchResultItemProps {
  img: React.ReactNode;
  name: React.ReactNode;
  type: React.ReactNode;
  searchKey?: string;
}

const getHighlightedText = (text: string, highlight: string) => {
  if (
    highlight.includes('?') ||
    highlight.includes('#') ||
    highlight.includes('^') ||
    highlight.includes('~') ||
    highlight.includes('`') ||
    highlight.includes('!') ||
    highlight.includes('@') ||
    highlight.includes('$') ||
    highlight.includes('%') ||
    highlight.includes('&') ||
    highlight.includes('*') ||
    highlight.includes('(') ||
    highlight.includes(')') ||
    highlight.includes('_') ||
    highlight.includes('-') ||
    highlight.includes('+') ||
    highlight.includes('=') ||
    highlight.includes('/') ||
    highlight.includes('>') ||
    highlight.includes('.') ||
    highlight.includes('<') ||
    highlight.includes(',') ||
    highlight.includes(';') ||
    highlight.includes(':') ||
    highlight.includes('{') ||
    highlight.includes('}') ||
    highlight.includes('[') ||
    highlight.includes(']') ||
    highlight.includes('\\') ||
    highlight.includes('|')
  ) {
    return text;
  }

  const parts = text.split(new RegExp(`(${highlight})`, 'gi'));

  return parts
    .filter((part) => part)
    .map((part, i) => (
      <span
        key={i}
        className={cn('text-text500', {
          'text-white': part.toLowerCase() === highlight.toLowerCase(),
        })}
      >
        {part}
      </span>
    ));
};

export const SearchResultItem: React.FC<SearchResultItemProps> = ({
  name,
  type,
  img,
  searchKey = '',
}) => {
  return (
    <div className="hover:bg-back300 flex w-full items-center gap-2 rounded-xl p-2.5">
      <div>{img}</div>
      <div className="w-0 flex-1">
        <span className="block w-full overflow-hidden truncate text-left text-xs no-underline">
          {typeof name === 'string'
            ? getHighlightedText(name, searchKey)
            : name}
        </span>
      </div>
      <div className="text-text600 flex w-[100px] items-center justify-center rounded-full border border-solid border-[#4f5794] px-1.5 py-0.5 text-center text-xs capitalize">
        {type}
      </div>
    </div>
  );
};

export const SearchSuggestItem = ({ name }) => {
  return (
    <div className="hover:bg-back300 flex w-full items-center gap-2 rounded-xl p-2.5">
      <div className="w-0 flex-1">
        <span className="block w-full overflow-hidden truncate text-left text-xs no-underline">
          {name}
        </span>
      </div>
    </div>
  );
};
